import { render, staticRenderFns } from "./CommonPortionStatusRenderer.vue?vue&type=template&id=51b0a428&"
import script from "./CommonPortionStatusRenderer.vue?vue&type=script&lang=js&"
export * from "./CommonPortionStatusRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports